/**
 * Featured Collection — Simple Horizontal Scroll
 * Drag + arrow buttons + scroll-snap.
 */
(function () {
  function init(container) {
    var strip = container.querySelector('.ode-fc__strip');
    var prevBtn = container.querySelector('.ode-fc__arrow--prev');
    var nextBtn = container.querySelector('.ode-fc__arrow--next');

    if (!strip) return;

    function getSlideWidth() {
      var slide = strip.querySelector('.ode-fc__slide');
      if (!slide) return 300;
      return slide.offsetWidth + 24; // 24px gap
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(strip.scrollLeft);
      var maxScroll = strip.scrollWidth - strip.clientWidth;
      prevBtn.disabled = scrollLeft <= 2;
      nextBtn.disabled = scrollLeft >= maxScroll - 2;
    }

    function scrollBy(direction) {
      strip.scrollBy({ left: getSlideWidth() * direction, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { scrollBy(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { scrollBy(1); });
    }

    strip.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  function ready() {
    var sections = document.querySelectorAll('.ode-fc--simple');
    sections.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
